import { useTheme } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { Alert, Grid, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { sendRequest, serviceList } from 'src/utils';
import ButtonAction from '../Button.js/SaveButton';
import ChessBoard from '../ChessBoard/ChessBoard';
import NumberInput from '../Input/NumberInput';
import Loader from '../loader/loader';
import ConfirmDeviceModal from './ConfirmDeviceModal';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const StyledProductImg = styled('img')({
    // top: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    // position: 'absolute',
});
const ExportDeviceModal = ({
    idDrawer,
    idCabinet,
    isReload = true,
    visible = false,
    dataUpdate,
    setVisible,
    idPermission,
    fuctGet,
    isQRCodeDevice = false,
    typeCabinet,
}) => {
    // region init variables
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const [visibleConfirm, setVisibleConfirm] = useState(false);
    const [quantity, setQuantity] = useState('');
    const [deviceCD, setDeviceCD] = useState('');
    const [cabinetCD, setCabinetCD] = useState('');

    const [actionDeviceOnline, setActionDeviceOnline] = useState(false);
    const actionRef = useRef();

    const [sendEmail, setSendEmail] = useState(false);
    const sendEmailRef = useRef();
    const [openCellFlag, setOpenCellFlag] = useState(true);
    const dataProcessIOT = useRef([]);

    useEffect(() => {
        setQuantity('');
        setDeviceCD(dataUpdate.device_cd);
        setCabinetCD(dataUpdate.cabinet_cd);
        if (visible) openCell(dataUpdate);
        return () => {
            clearIntervalCheckStatusCell();
        };
    }, [visible]);

    // region openCell
    const openCell = (data) => {
        if (!data?.cell_lc) return;
        if (actionRef.current) return;
        setActionDeviceOnline(true);
        setOpenCellFlag(true);
        actionRef.current = true;
        dataProcessIOT.current = [
            +idPermission,
            dataUpdate.cabinet_id,
            dataUpdate.drawer_id,
            +quantity,
            dataUpdate.device_id,
            isQRCodeDevice ? dataUpdate.cell_id : dataUpdate.id,
            'exp',
            'ewh',
        ];
        let service = serviceList.openCellIOT;
        let inpuVal = [data.cabinet_cd, data.drawer_lc, data.cell_lc.row, data.cell_lc.column];
        if (data?.cabinet_type !== 'round') {
            service = serviceList.openCellIOT;
            inpuVal = [data.cabinet_cd, data.drawer_lc, data.cell_lc.row, data.cell_lc.column];
        } else {
            service = serviceList.openCellIOTCabinetV2;
            inpuVal = [data.cabinet_cd, data.drawer_lc, data.cell_lc.column, data.column];
        }
        sendRequest(service, inpuVal, openCellResult, true, timeOutFunctIOT, 40000, 0);
    };

    // region openCellResult
    const openCellResult = (reqInfoMap, message) => {
        setActionDeviceOnline(false);
        actionRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            setVisible(false);
        } else {
            setOpenCellFlag(false);
            // gọi api kiểm tra trạng thái ô sau 5s
            const input_param = reqInfoMap['input_param'];
            handleIntervalCheckStatusCell(input_param[0], input_param[1], input_param[2]);
            // region
        }
    };

    // region Close cell
    const closeCell = () => {
        setActionDeviceOnline(true);
        clearIntervalCheckStatusCell();
        let service = serviceList.closeCellIOT;
        let inpuVal = [dataUpdate.cabinet_cd, dataUpdate.drawer_lc, dataUpdate.cell_lc.row, dataUpdate.cell_lc.column];
        if (dataUpdate?.cabinet_type !== 'round') {
            service = serviceList.closeCellIOT;
            inpuVal = [dataUpdate.cabinet_cd, dataUpdate.drawer_lc, dataUpdate.cell_lc.row, dataUpdate.cell_lc.column];
        } else {
            service = serviceList.closeCellIOTCabinetV2;
            inpuVal = [dataUpdate.cabinet_cd, dataUpdate.drawer_lc, dataUpdate.cell_lc.column, dataUpdate.column];
        }
        sendRequest(service, inpuVal, closeCellResult, true, timeOutFunctIOT, 40000, 0);
    };

    // region closeCellResult
    const closeCellResult = (reqInfoMap, message) => {
        setActionDeviceOnline(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
        } else {
            setVisible(!visible);
        }
        clearIntervalCheckStatusCell();
    };

    // region timeOutFunctIOT
    const timeOutFunctIOT = (reqInfo) => {
        setActionDeviceOnline(false);
        setOpenCellFlag(false);
        setVisible(false);
        actionRef.current = false;
        toast.error(t('error.time_out') + ': ' + 'IOT');
    };

    // region handleExport
    const handleExport = () => {
        if (!quantity) return toast.error(t('error.param'));
        if (actionRef.current) return;
        setActionDeviceOnline(true);
        actionRef.current = true;
        if (!dataUpdate.cabinet_id || !dataUpdate.drawer_id) return toast.error(t('error.system_error'));
        // if (addCabinetFlag.current === true) return;
        if (!quantity) return toast.error(t('error.param'));

        let InVal = [
            +idPermission,
            dataUpdate.cabinet_id,
            dataUpdate.drawer_id,
            +quantity,
            dataUpdate.device_id,
            isQRCodeDevice ? dataUpdate.cell_id : dataUpdate.id,
            'exp',
            'ewh',
        ];
        sendRequest(serviceList.export, InVal, actionResult, true, timeOutFunct, 40000);
    };

    // region actionResult
    const actionResult = (reqInfoMap, message) => {
        setActionDeviceOnline(false);
        actionRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            closeCell();
            setVisible(false);
            return;
        } else {
            toast.success(message['proc_message']);
            setVisible(!visible);
            closeCell();
            sendEmailDevice();
            if (isReload && isQRCodeDevice) {
                fuctGet && fuctGet(deviceCD, cabinetCD);
            } else if (isReload) fuctGet && fuctGet(idCabinet, idDrawer);
        }
    };

    const timeOutFunct = (reqInfo) => {
        setActionDeviceOnline(false);
        actionRef.current = false;
        closeCell();
        toast.error(t('error.time_out'));
    };

    // region sendEmailDevice
    const sendEmailDevice = () => {
        if (sendEmailRef.current) return;
        setSendEmail(true);
        sendEmailRef.current = true;

        let InVal = [dataUpdate.device_id, isQRCodeDevice ? dataUpdate.cell_id : dataUpdate.id];
        sendRequest(serviceList.sendEmailDevice, InVal, sendEmailDeviceResult, true, timeOutFunctSendEmail, 40000);
    };
    // region sendEmailDeviceResult
    const sendEmailDeviceResult = (reqInfoMap, message) => {
        setSendEmail(false);
        sendEmailRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            return;
        } else {
            // console.log('Gửi thành công')
            return;
        }
    };

    // region timeOutFunctSendEmail
    const timeOutFunctSendEmail = (reqInfo) => {
        setSendEmail(false);
        sendEmailRef.current = false;
    };
    // console.log("exportModal: ", typeCabinet)

    const handleClose = () => {
        closeCell();
        // setVisible(!visible);
    };

    // region checkStatusCell START
    const checkIntervalCheckStatusCell = useRef(null);
    const checkStatusCellFlag = useRef(false);
    const handleIntervalCheckStatusCell = (cabinet_cd, drawer_id, cell_address) => {
        checkIntervalCheckStatusCell.current = setInterval(() => {
            checkStatusCell(cabinet_cd, drawer_id, cell_address);
        }, 3000);
    };
    const clearIntervalCheckStatusCell = () => {
        console.log('checkIntervalCheckStatusCell.current', checkIntervalCheckStatusCell.current);
        clearInterval(checkIntervalCheckStatusCell.current);
    };
    const checkStatusCell = (cabinet_cd, drawer_id, cell_address) => {
        console.log('checkIntervalCheckStatusCell.current', checkIntervalCheckStatusCell.current);
        if (!cabinet_cd || !drawer_id || !cell_address || checkStatusCellFlag.current) return;
        checkStatusCellFlag.current = true;
        const inpuVal = [cabinet_cd, drawer_id, cell_address];
        sendRequest(
            serviceList.checkStatusCell,
            inpuVal,
            checkStatusCellResult,
            true,
            checkStatusCellTimeOut,
            40000,
            0
        );
    };
    const checkStatusCellResult = (reqInfoMap, message) => {
        checkStatusCellFlag.current = false;
        console.log(
            'checkStatusCellResult',
            (message['proc_code']?.toString() || '1') === '1' && (message['proc_status']?.toString() || '1') === '1'
        );
        if ((message['proc_code']?.toString() || '1') === '1' && (message['proc_status']?.toString() || '1') === '1') {
            closeCell();
        }
    };
    const checkStatusCellTimeOut = (reqInfo) => {
        checkStatusCellFlag.current = false;
    };
    // region checkStatusCell END
    return (
        <BootstrapDialog
            fullScreen={fullScreen}
            open={visible}
            // onClose={() => setVisible(!visible)}
            aria-labelledby="customized-dialog-title"
        >
            <Loader loading={actionDeviceOnline} />
            <BootstrapDialogTitle onClose={handleClose} id="customized-dialog-title">
                {typeCabinet === 'round'
                    ? `${t('export_device')} ${t('ordinal_number')}: [ ${dataUpdate?.cell_lc?.column} ]`
                    : `${t('export_device')} ${t('cell')}: [ ${dataUpdate?.cell_lc?.row} : ${
                          dataUpdate?.cell_lc?.column
                      } ]`}
            </BootstrapDialogTitle>
            <DialogContent dividers>
                <Alert sx={{ alignItems: 'flex-start' }} severity="warning" style={{ marginBottom: '20px' }}>
                    <div>
                        <Typography fontWeight="lg" sx={{ fontWeight: '600', fontSize: '17px' }} mt={0.25}>
                            {t('note')}
                        </Typography>
                        <Typography fontSize="sm" sx={{ opacity: 0.8 }}>
                            {t('modal_confirm')}
                            <b> {t('modal_tt')} </b>
                            {t('thanks_modal')}
                        </Typography>
                    </div>
                </Alert>
                <ConfirmDeviceModal
                    visible={visibleConfirm}
                    setVisible={setVisibleConfirm}
                    title={t('confirm')}
                    handleSave={() => {
                        closeCell();
                    }}
                />
                <Loader loading={actionDeviceOnline} />
                <Grid container spacing={2}>
                    <Grid item style={{ width: '100%' }} xl={12} md={12} sm={12}>
                        <NumberInput
                            label={t('quantity_category')}
                            valueChange={quantity}
                            autoFocus
                            required
                            getValue={setQuantity}
                        />
                    </Grid>
                    {dataUpdate?.cabinet_type !== 'round' && (
                        <ChessBoard
                            rows={dataUpdate?.row}
                            columns={dataUpdate?.column}
                            activePosition={{
                                row: dataUpdate?.cell_lc?.row ? dataUpdate.cell_lc.row : 1,
                                column: dataUpdate?.cell_lc?.column ? dataUpdate.cell_lc.column : 1,
                            }}
                            typeCabinet={typeCabinet}
                        />
                    )}
                </Grid>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction onClick={handleClose} type={'cancel'} title={t('cancel') + ' ' + t('export')} />
                <ButtonAction
                    onClick={handleExport}
                    type={'export'}
                    disabled={openCellFlag}
                    title={t('comfirm') + ' ' + t('export')}
                />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default ExportDeviceModal;
